import React from 'react';
import { connect } from 'react-redux';
import { Checkbox } from 'react-bootstrap';
import { toggleCheckbox } from 'actions/request';

const PublicationOption = ({ request, toggleCheckbox }) => {
  return (
    <Checkbox
      id="certificationOption"
      onChange={toggleCheckbox}
      value={request.certificationOption}
      checked={request.certificationOption}
    >
      Publish this device on the{' '}
      <a
        href="https://www.cbrsalliance.org/"
        target="_blank"
        rel="noopener noreferrer"
      >
        cbrsalliance.org
      </a>{' '}
      certified devices list once certified
    </Checkbox>
  );
};

function mapStateToProps({ request }) {
  return { request };
}

export default connect(
  mapStateToProps,
  { toggleCheckbox }
)(PublicationOption);



// WEBPACK FOOTER //
// ./src/components/PublicationOption.js